var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.184 8.329c2.123-.742 3.364-2.762 2.952-4.805C11.723 1.482 9.774 0 7.5 0 5.228 0 3.279 1.482 2.866 3.524c-.413 2.043.829 4.063 2.952 4.805-3.196.685-5.544 3.175-5.814 6.164a.438.438 0 00.202.421.535.535 0 00.501.043.455.455 0 00.284-.38c.255-3.114 3.093-5.52 6.51-5.52 3.416 0 6.255 2.406 6.51 5.52.021.233.234.414.491.415h.041a.509.509 0 00.34-.156.424.424 0 00.115-.33c-.264-2.994-2.614-5.49-5.814-6.177zM3.78 4.309C3.782 2.432 5.45.912 7.504.913c2.055.002 3.72 1.524 3.718 3.402 0 1.877-1.666 3.399-3.721 3.399-2.056-.003-3.722-1.526-3.722-3.405z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
export default SvgUser;